import React from 'react';
import { TextField, Button, FormControlLabel, Radio, RadioGroup, Dialog, DialogTitle, DialogContent, DialogActions, Typography } from '@mui/material';

const BluetoothResetDialog = ({ 
    open, 
    onClose,
    settings,
    bluetoothResetOption,
    setBluetoothResetOption,
    bluetoothCustomPasscode,
    setBluetoothCustomPasscode,
    onConfirm
}) => {
    return (
        <Dialog open={open} onClose={onClose} maxWidth={'md'}>
            <DialogTitle>Reset Bluetooth Relay</DialogTitle>
            <DialogContent>
                <Typography component="div">
                    {settings.ResetBluetooth && (
                        <Typography style={{color: 'red', marginBottom: 20}}>Pending reset</Typography>
                    )}
                    <div>
                        Your Bluetooth relay has a passcode which is how we communicate with and identify it.
                        The current passcode is {settings.BluetoothPasscode} which 
                        was the last previously set passcode on the physical relay using the app.
                        You may reset the relay in one of three ways.
                    </div>
                    <RadioGroup
                        aria-labelledby="radio-buttons-group-label"
                        value={bluetoothResetOption}
                        name="radio-buttons-group"
                        onChange={(e) => setBluetoothResetOption(e.target.value)}
                    >
                        <FormControlLabel 
                            value="basic" 
                            control={<Radio disabled={!settings.BluetoothPasscode} />} 
                            label="Basic Reset" 
                        /> 
                        Selecting this option will allow you to run through the
                        Bluetooth setup on the app. The app will use the existing passcode of {settings.BluetoothPasscode} to reset your relay with a 
                        new passcode, thereby re-pairing with this kiosk.
                        Use this option if you are using the relay currently set up with this kiosk, and you just want
                        to go back to the Bluetooth set up screen to set a new passcode.
                        
                        <FormControlLabel 
                            value="reset" 
                            control={<Radio />} 
                            label="Reset using the passcode 1234" 
                        /> 
                        Use this option if you 
                        are setting up a brand new relay. New relays start with the passcode 1234. As you run through the set up on the app, the relay will be 
                        reset with a new passcode and paired with this kiosk.
                        
                        <FormControlLabel 
                            value="custom" 
                            control={<Radio />} 
                            label="Reset using a custom passcode" 
                        /> 
                        Use this option if you are
                        changing a pre-configured relay to be used on this kiosk, where you already know the passcode
                        that was previously set on the relay. For example, you are swapping your relay from one device to another.
                        
                        <TextField 
                            label='Custom passcode' 
                            style={{marginTop: 10}} 
                            disabled={bluetoothResetOption !== 'custom'}  
                            size='small' 
                            onChange={(e) => setBluetoothCustomPasscode(e.target.value)} 
                        />
                        
                        {settings.ResetBluetooth && (
                            <>
                                <FormControlLabel 
                                    value="cancel" 
                                    control={<Radio />} 
                                    label="Cancel reset" 
                                />
                                Choose this option if you want to cancel the pending reset. 
                            </>
                        )}
                    </RadioGroup>
                    <div>&nbsp;</div>
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onConfirm}>OK</Button>
                <Button onClick={onClose}>Cancel</Button>
            </DialogActions>
        </Dialog>
    );
};

export default BluetoothResetDialog;

